import PageHero from "@/components/layout/PageHero";
import SEO from "@/components/layout/SEO";
import FeatureList from "@/components/layout/FeatureList";
import EnglishExamCrossSell from "@/components/layout/EnglishExamCrossSell";
import EntryExamCrossSell from "@/components/layout/EntryExamCrossSell";
import PremiumForm from "@/components/forms/PremiumForm";
import FinalCTA from "@/components/home/FinalCTA";
import { IMG, BOOKING_URLS } from "@/lib/content";

const ITEMS = [
  { title: "Selective admissions, decoded", body: "Which programs actually accept your profile — and what each university really weighs." },
  { title: "Entry exam preparation", body: "MD & DDS entrance exams: scope, format and realistic preparation plans." },
  { title: "Institution fit strategy", body: "Ranking signals, clinical rotations, English-language program quality, and graduate outcomes." },
  { title: "Beyond admission", body: "Residency paths, recognition in your home country, and early career planning from year one." },
];

export default function MedicineDentistry() {
  return (
    <div data-testid="page-medicine-dentistry">
      <SEO
        title="Medicine & Dentistry in Poland — premium admissions"
        description="Premium, institution-specific guidance for Medicine and Dentistry candidates in Poland. Entrance exams, English requirements, and admission strategy."
        path="/medicine-dentistry"
      />
      <PageHero
        overline="Premium · Medicine & Dentistry"
        title={<>Medicine & Dentistry in Poland — <span className="italic text-[#D7141A]">selective</span> by design.</>}
        subtitle="Premium, institution-specific guidance for serious Medicine and Dentistry candidates. You should not disappear into a general funnel — and here, you won't."
        image={IMG.medical}
        ctaPrimary={{ to: BOOKING_URLS.medicine, label: "Discuss My Path" }}
        ctaSecondary={{ to: "/free-resources", label: "Entry Guide" }}
      />
      <FeatureList
        overline="Premium scope"
        title="What serious candidates actually need."
        intro="The difference between a good application and a successful one is usually institution-level strategy."
        items={ITEMS}
      />
      <EnglishExamCrossSell
        level="B2 / C1"
        context="Medicine & Dentistry programs in Poland require"
        testId="medicine-english-cross-sell"
      />
      <EntryExamCrossSell
        context="Medicine & Dentistry programs in Poland always include"
        note="Selective — entrance exam required for every candidate."
        testId="medicine-entry-exam-cross-sell"
      />
      <section className="section-pad bg-[#EBE9E1]/60" id="premium" data-testid="medicine-premium-form-section">
        <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline">Premium application strategy</div>
            <h2 className="font-serif text-3xl sm:text-4xl text-[#0D1B2A] mt-3 leading-tight">Tell us about your profile.</h2>
            <p className="text-[#4A5568] mt-5 leading-relaxed">
              A senior advisor will review your academic background and target universities, then reach out with an honest view of your chances and your best next steps.
            </p>
          </div>
          <div className="lg:col-span-7">
            <PremiumForm defaultTrack="Medicine" testPrefix="medicine-premium" />
          </div>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
}
